import { RankedTester, and, rankWith, optionIs, isNumberControl } from "@jsonforms/core";

export const GalleryMidiaIdTest: RankedTester = rankWith(
  3,
  and(isNumberControl, optionIs("mediaGallery", true))
);

export default GalleryMidiaIdTest;
